/* Composeur sur mesure (section to-composer) : état du formulaire -> moteur (to-moteur.js, kitPour) -> photo du kit avec sa
   pierre, économies, kit déjà confectionné, kit supérieur, ajout au panier sur place (petit lien vers la fiche du kit).
   9 oct. 2026 (Claude Code pour Raphaël) : toute sélection renvoie vers un kit avec pierre (variante volume + pierre ;
   balance et loupe incluses par le kit, sinon pré-cochées dans « Complétez votre kit » par &balance=1&loupe=1).
   Plus de choix « sans pierre » ni de kit supérieur à surcoût négatif. Paramètres d'URL : reactifs, vol, pierre, balance, loupe.
   Relecture du 9 oct. : un kit plus complet et moins cher (ou au même prix) passe en choix principal (« Plus complet et
   moins cher : + 9K ») ; écarts négatifs affichés « −X € » ; accessoires imposés par le seul kit disponible (« Ce kit
   inclut aussi… ») : leurs cases sont cochées d'office (data-impose), et décochées au rendu suivant s'il ne les impose plus.
   Recette du 9 oct. : ajout direct au panier, le kit en tête du panier ; sous 900 px, la bulle de l'assistant se retire tant
   que le formulaire passe dessous.
   Soir du 9 oct. : balance avec un kit (remise « Balance à 13,99 € avec votre kit », config.prixBalanceKit) : comptée à ce
   prix par le moteur ; prix seule barré sur la carte balance de l'étape 4 dès qu'un kit est retenu, et dans les lignes.
   10 oct. (Raphaël : « ajouter au panier, pas rediriger vers une autre page ») : le bouton principal « Ajouter au panier · X € »
   (résultat et barre mobile) met le kit puis les accessoires cochés au panier et ouvre le panier latéral, sans quitter la page ;
   plus de bouton secondaire ; un petit lien « Voir le détail du kit » mène à la fiche. « Ajouté ✓ » un instant, puis le libellé
   revient ; un clic pendant l'ajout (double clic) ou pendant « Ajouté ✓ » est ignoré.
   10 oct., plus tard (Raphaël : « une option avec ou sans coffret en bois ») : étape « Présentation » après la pierre,
   « Pochette » (incluse, cochée par défaut) ou « Coffret en bois » (+22 € en 5 ml, +25 € en 15 ml : prix des variantes du
   produit option, config.coffret). Le total, la carte du kit (« + coffret en bois », lignes), la barre mobile et l'ajout au
   panier (kit, coffret du bon volume, puis accessoires) en tiennent compte. Paramètre d'URL coffret=1. Le lien « Existe aussi
   en coffret bois » ne reste que pour un coffret qui inclut un accessoire ou qui coûte moins cher (moteur, garderCoffret). */
(function () {
  var racine = document.querySelector("[data-compo]");
  if (!racine || !window.TestOrMoteur) return;
  var M = window.TestOrMoteur;
  var $ = function (s, c) { return (c || racine).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || racine).querySelectorAll(s)); };
  var lireJSON = function (s) { try { return JSON.parse($(s).textContent); } catch (e) { return null; } };
  var config = lireJSON("[data-compo-config]"), produits = lireJSON("[data-compo-produits]");
  if (!config || !produits) return;
  var cat = M.catalogue(produits, config);
  var form = $("[data-compo-form]"), photo = $("[data-compo-photo]"), resultat = $("[data-compo-resultat]");
  var base = racine.getAttribute("data-base") || "";
  var euros = function (x) { return (Math.round(x * 100) / 100).toFixed(2).replace(".", ",").replace(",00", "") + " €"; };
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  // Libellés de la section (réglages du thème), avec leurs valeurs par défaut
  var libAjouter = racine.getAttribute("data-ajouter-texte") || "Ajouter au panier";
  var libAjoute = racine.getAttribute("data-ajoute-texte") || "Ajouté ✓";
  var libFiche = racine.getAttribute("data-fiche-texte") || "Voir le détail du kit";
  var dernierKit = null, courant = null;

  // srcset d'une image du CDN Shopify (paramètre width=) : 400, 800 et 1200 px ; rien pour une autre URL.
  var jeuImage = function (u) {
    return /[?&]width=\d+/.test(u) ? [400, 800, 1200].map(function (w) { return u.replace(/([?&]width=)\d+/, "$1" + w) + " " + w + "w"; }).join(", ") : "";
  };
  var prixDe = function (p, f) { var v = p && p.variantes.filter(function (x) { return x.dispo && f(x); })[0]; return v ? v.prix : null; };
  var choix = function () {
    return {
      codes: $$("input[name='reactif']:checked").map(function (i) { return i.value; }),
      vol: parseInt((($("input[name='vol']:checked") || {}).value) || "5", 10),
      pierre: parseInt((($("input[name='pierre']:checked") || {}).value) || "62", 10) === 150 ? 150 : 62,
      balance: !!$("input[name='balance']:checked"),
      loupe: !!$("input[name='loupe']:checked"),
      coffret: !!$("input[name='coffret'][value='1']:checked")
    };
  };
  var avec = function (c, champs) { var x = { codes: c.codes.slice(), vol: c.vol, pierre: c.pierre, balance: c.balance, loupe: c.loupe, coffret: c.coffret }; Object.keys(champs).forEach(function (k) { x[k] = champs[k]; }); return x; };
  var ecart = function (d) { return d > 0.005 ? "+" + euros(d) : (d < -0.005 ? "−" + euros(-d) : "Sans surcoût"); };
  // Prix avec le kit, puis prix habituel barré (« au lieu de » pour les lecteurs d'écran ; le barré passe devant à l'écran)
  var prixBarre = function (prix, habituel) {
    return '<span class="prix-kit prix-kit--ligne"><span class="prix-kit__offre">' + esc(prix) + '</span> <s class="prix-kit__barre"><span class="sr-only">au lieu de </span>' +
      esc(euros(habituel)) + "</s></span>";
  };
  var totalKit = function (c) { var r = M.kitPour(cat, c, { superieur: false }); return r && r.kit ? r.total : null; };

  // Prix affichés sur les choix : ce que chaque case change au kit proposé (lu dans le catalogue, jamais écrit en dur).
  var majPrixChoix = function (c, r) {
    var actuel = r && r.kit ? r.total : null;
    $$("[data-prix-reactif]").forEach(function (el) {
      var code = el.getAttribute("data-prix-reactif"), lab = el.closest("label"), inp = lab.querySelector("input");
      var dispo = prixDe(cat.reactifs[code], function (x) { return x.vol === c.vol; }) !== null;
      lab.classList.toggle("is-indispo", !dispo);
      inp.disabled = !dispo;
      if (!dispo) { el.textContent = "Indisponible"; return; }
      if (inp.checked) { el.textContent = "Inclus"; return; }
      var t = totalKit(avec(c, { codes: c.codes.concat(code) }));
      el.textContent = t === null ? "" : (actuel === null ? euros(t) : ecart(t - actuel));
    });
    $$("[data-prix-pierre]").forEach(function (el) {
      var taille = parseInt(el.getAttribute("data-prix-pierre"), 10);
      if (taille === 62) { el.textContent = "Incluse"; return; }
      var t150 = c.codes.length ? totalKit(avec(c, { pierre: 150 })) : null, t62 = c.codes.length ? totalKit(avec(c, { pierre: 62 })) : null;
      el.textContent = t150 !== null && t62 !== null ? ecart(t150 - t62) : "";
    });
    $$("[data-prix-acc]").forEach(function (el) {
      var role = el.getAttribute("data-prix-acc"), inp = el.closest("label").querySelector("input");
      if (inp.hasAttribute("data-impose")) { el.textContent = "Inclus"; return; } // imposé par le kit proposé
      var seul = prixDe(cat[role], function () { return true; });
      inp.disabled = seul === null && !inp.checked;
      if (seul === null) { el.textContent = "Indisponible"; return; }
      var o = {}; o[role] = true; var n = {}; n[role] = false;
      var tAvec = c.codes.length ? totalKit(avec(c, o)) : null, tSans = c.codes.length ? totalKit(avec(c, n)) : null;
      if (tAvec === null || tSans === null) { el.textContent = "+" + euros(seul); return; }
      var d = tAvec - tSans;
      // Balance avec un kit : elle coûte moins qu'achetée seule (remise automatique) : prix seule barré, puis l'écart
      if (role === "balance" && cat.prixBalanceKit && d > 0.005 && d < seul - 0.005) el.innerHTML = prixBarre("+" + euros(d), seul);
      else el.textContent = ecart(d);
    });
    // Coffret en bois : le supplément au volume choisi (variante « Pour flacons 5 ml » ou « 15 ml » du produit option)
    $$("[data-prix-coffret]").forEach(function (el) {
      var inp = el.closest("label").querySelector("input"), pc = prixDe(cat.optionCoffret, function (x) { return x.vol === c.vol; });
      inp.disabled = pc === null && !inp.checked;
      if (pc === null) { el.textContent = "Indisponible"; return; }
      var tAvec = c.codes.length ? totalKit(avec(c, { coffret: true })) : null, tSans = c.codes.length ? totalKit(avec(c, { coffret: false })) : null;
      el.textContent = tAvec === null || tSans === null ? "+" + euros(pc) : ecart(tAvec - tSans);
    });
  };

  // Ligne du coffret : « Coffret en bois · Pour flacons 5 ml » (le titre du produit option est long pour une ligne)
  var titreLigne = function (l) { return l.role === "coffret" ? "Coffret en bois · " + l.titre.split(" · ").pop() : l.titre; };
  var lignesHTML = function (lignes) {
    return '<ul class="compo__lignes">' + lignes.map(function (l) {
      return "<li><span>" + esc(titreLigne(l)) + "</span><b>" + (l.prixHabituel ? prixBarre(euros(l.prix), l.prixHabituel) : euros(l.prix)) + "</b></li>";
    }).join("") + "</ul>";
  };
  var liste = function (t) { return t.length < 2 ? t.join("") : t.slice(0, -1).join(", ") + " et " + t[t.length - 1]; };
  var NOM_ACC = { balance: "la balance 0,01 g", loupe: "la loupe éclairée", coffret: "le coffret en bois" };
  var etiquette = function (r) {
    return r.plusComplet ? "Plus complet et moins cher : + " + liste(r.plusComplet.ajouts) : (r.exact ? "Votre kit sur mesure" : "Le kit le plus proche");
  };

  var majURL = function (c) {
    if (!window.history.replaceState) return;
    var u = new URL(location.href);
    ["reactifs", "vol", "pierre", "coffret", "balance", "loupe"].forEach(function (k) { u.searchParams.delete(k); });
    if (c.codes.length) {
      u.searchParams.set("reactifs", c.codes.join(","));
      if (c.vol === 15) u.searchParams.set("vol", "15");
      if (c.pierre === 150) u.searchParams.set("pierre", "150");
      if (c.coffret) u.searchParams.set("coffret", "1");
      if (c.balance) u.searchParams.set("balance", "1");
      if (c.loupe) u.searchParams.set("loupe", "1");
    }
    history.replaceState(history.state, "", u);
  };

  var rendre = function () {
    // Nouvelle sélection : « Ajouté ✓ » parlait de la précédente, le libellé revient (un ajout en cours reste verrouillé)
    if (ajout.etat === "ajoute") { clearTimeout(minuterie); ajout = { etat: "", genre: "" }; }
    // Cases cochées d'office au rendu précédent : on repart de la sélection du client.
    $$("input[data-impose]").forEach(function (i) { i.checked = false; i.removeAttribute("data-impose"); });
    var c = choix(), r = M.kitPour(cat, c), imposes = [];
    // Accessoires imposés : la seule version disponible du kit les inclut ; cases cochées, sélection recalculée.
    if (r && r.kit && r.imposes && r.imposes.length) {
      r.imposes.forEach(function (role) {
        var i = $("input[name='" + role + "']");
        if (i && !i.checked) { i.checked = true; i.setAttribute("data-impose", ""); imposes.push(role); }
      });
      if (imposes.length) { c = choix(); r = M.kitPour(cat, c); }
    }
    courant = r;
    majPrixChoix(c, r);
    // Étapes franchies (jauge de progression)
    $$(".compo__progres li").forEach(function (li) { li.classList.toggle("is-fait", c.codes.length > 0); });
    // Photo : le kit avec sa pierre (image de la variante) ; à défaut la photo des flacons de la combinaison
    var vide = !r;
    $("[data-compo-vide]").hidden = !vide;
    photo.classList.toggle("is-vide", vide);
    if (!vide) {
      var src = r.kit && r.kit.photo ? r.kit.photo : base + "pc-" + r.cle + "-600.webp";
      if (photo.getAttribute("src") !== src) {
        photo.classList.remove("is-change"); void photo.offsetWidth; photo.classList.add("is-change");
        // Photo du kit : URL du CDN exportée à 400 px ; srcset 400 / 800 / 1200 px pour rester net sur grand écran
        var jeu = r.kit && r.kit.photo ? jeuImage(src) : "";
        if (jeu) { photo.setAttribute("srcset", jeu); photo.setAttribute("sizes", "(min-width: 980px) 45vw, 100vw"); }
        else { photo.removeAttribute("srcset"); photo.removeAttribute("sizes"); }
        photo.src = src;
      }
      photo.alt = r.kit && r.kit.photo ? r.kit.titre + ", " + r.kit.variante.titre
        : c.codes.length + " flacon" + (c.codes.length > 1 ? "s" : "") + " de réactif Test-Or : " + c.codes.map(function (x) { return M.NOMS[x]; }).join(", ");
    }
    $("[data-compo-legende]").hidden = vide || c.vol !== 15;
    // Pastille quand le kit exact existe (effet quand il change)
    var cleKit = r && r.kit && (r.exact || r.plusComplet) ? r.kit.handle + r.kit.variante.id : null;
    var badge = $("[data-compo-debloque]");
    badge.hidden = !cleKit;
    if (cleKit && cleKit !== dernierKit) { badge.classList.remove("is-pop"); void badge.offsetWidth; badge.classList.add("is-pop"); }
    dernierKit = cleKit;
    // Jauge d'économies : le kit face aux mêmes articles achetés séparément
    var eco = r ? r.economie : 0;
    $("[data-compo-jauge]").hidden = vide;
    $("[data-compo-eco]").textContent = euros(eco);
    $("[data-compo-barre]").style.width = (r && r.carte.total ? Math.min(100, Math.round(eco / r.carte.total * 400)) : 0) + "%";
    // L'adresse garde la sélection du client : un accessoire coché d'office (imposé par le kit) n'y figure pas
    var cu = avec(c, {}); imposes.forEach(function (role) { cu[role] = false; });
    majURL(cu);

    if (vide) { resultat.innerHTML = '<p class="compo__astuce">Cochez au moins un métal : le kit avec pierre qui vous correspond s\'affiche ici.</p>'; majMobile(null); marquer(); return; }
    var h = "";
    if (r.kit) {
      var k = r.kit, pc = r.plusComplet;
      h += '<div class="compo__offre' + (r.exact || pc ? " is-pack" : "") + '"><span class="compo__etiquette">' + esc(etiquette(r)) + "</span>" +
        '<div class="compo__offre-tete">' + (k.image ? '<img src="' + esc(k.image) + '" alt="" width="72" height="72" loading="lazy">' : "") +
        "<div><strong>" + esc(k.titre) + "</strong><small>" + esc(k.variante.titre) + "</small>" +
        (r.optionCoffret ? '<small class="compo__en-coffret">+ coffret en bois</small>' : "") + "</div></div>";
      if (pc) {
        var nomsAcc = (pc.exact.optionCoffret ? [NOM_ACC.coffret] : []).concat(pc.exact.accessoires.map(function (a) { return NOM_ACC[a.role] || a.titre; }));
        h += '<p class="compo__aide">Ce kit contient aussi : ' + esc(liste(r.ajouts)) + (pc.economie > 0.005 ? ", pour " + euros(pc.economie) + " de moins que " : ", au même prix que ") +
          esc(pc.exact.kit.titre) + (nomsAcc.length ? " avec " + esc(liste(nomsAcc)) : "") + " (" + euros(pc.exact.total) + ").</p>";
      } else if (!r.exact) h += '<p class="compo__aide">Ce kit contient aussi : ' + esc(liste(r.ajouts)) + ".</p>";
      if (imposes.length) h += '<p class="compo__aide">Ce kit inclut aussi ' + esc(liste(imposes.map(function (a) { return NOM_ACC[a] || a; }))) + " : c'est la seule version disponible pour le moment.</p>";
      // Lignes du panier dès qu'il y a plus que le kit : kit, coffret en bois, accessoires
      if (r.lignes.length > 1) h += lignesHTML(r.lignes);
      h += '<p class="compo__prix"><b>' + euros(r.total) + "</b>" + (r.economie > 0 ? " <span>au lieu de " + euros(r.carte.total) + " en articles séparés</span>" : "") + "</p>" +
        (r.economie > 0 ? '<p class="compo__eco">Vous économisez ' + euros(r.economie) + "</p>" : "");
      var ensemble = (r.optionCoffret ? [NOM_ACC.coffret] : []).concat(r.accessoires.map(function (a) { return NOM_ACC[a.role] || a.titre; }));
      if (ensemble.length) h += '<p class="compo__aide">Ajoutés ensemble au panier : ' + esc(liste(["le kit"].concat(ensemble))) + ".</p>";
      if (r.indisponibles.length) h += '<p class="compo__alerte">Indisponible pour le moment : ' + esc(liste(r.indisponibles.map(function (a) { return NOM_ACC[a] || a; }))) + ".</p>";
      h += "</div>";
      // Coffret complet qui inclut un accessoire (Coffret Expert…) ou moins cher que le kit avec l'option ; avec le coffret
      // coché, ce qu'il fait gagner face au kit + coffret + accessoires
      if (r.coffret) {
        var gainCoffret = r.optionCoffret ? r.total - r.coffret.total : 0;
        h += '<p class="compo__alt">Existe aussi en coffret bois : <a href="' + esc(r.coffret.lien) + '">' + esc(r.coffret.titre) + "</a> · " + euros(r.coffret.total) +
          (gainCoffret > 0.005 ? " (" + euros(gainCoffret) + " de moins)" : "") + "</p>";
      }
      if (r.superieur) {
        var s = r.superieur;
        h += '<div class="compo__upsell"><span class="compo__etiquette compo__etiquette--or">Le bon plan</span>' +
          "<p>Pour <b>+" + euros(s.surcout) + "</b>, passez au <strong>" + esc(s.kit.titre) + "</strong> : vous ajoutez " + esc(liste(s.ajouts)) +
          " (valeur " + euros(s.bonus) + " en recharges).</p>" +
          '<button type="button" class="btn btn--ghost compo__passer" data-compo-passer>Passer à ce kit · ' + euros(s.total) + "</button></div>";
      }
      // Bouton principal : ajout au panier sur place (kit puis accessoires) ; la fiche du kit reste à un petit lien
      var libKit = libAjouter + " · " + euros(r.total);
      h += '<button type="button" class="btn btn--primary btn--block compo__cta" data-compo-ajouter data-libelle="' + esc(libKit) + '">' + esc(libKit) + "</button>" +
        '<p class="compo__fiche"><a href="' + esc(r.url) + '" data-compo-voir>' + esc(libFiche) + "</a></p>";
      if (pc) {
        h += '<p class="compo__alt">Sans ' + esc(liste(pc.ajouts)) + ' : <a href="' + esc(pc.exact.url) + '">' + esc(pc.exact.kit.titre) + "</a> · " + euros(pc.exact.total) + "</p>";
      } else if (!r.exact && !r.carte.manque.length && r.carte.lignes.length) {
        h += '<p class="compo__alt">Ou seulement vos réactifs et la pierre, à la carte : <b>' + euros(r.carte.total) + '</b> <button type="button" class="compo__lien" data-compo-carte data-libelle="Ajouter à la carte">Ajouter à la carte</button></p>';
      }
      h += '<p class="compo__note">Expédié sous 24 h ouvrées. Satisfait ou remboursé 14 jours.</p>';
    } else {
      // Repli : aucun kit ne convient (catalogue incomplet) : la sélection à la carte, pierre comprise
      if (r.carte.manque.length) h += '<p class="compo__alerte">Indisponible en ' + c.vol + " ml : " + esc(r.carte.manque.join(", ")) + ".</p>";
      if (r.carte.lignes.length) {
        h += '<div class="compo__offre"><span class="compo__etiquette">Votre sélection</span>' + lignesHTML(r.carte.lignes) +
          '<p class="compo__prix"><b>' + euros(r.carte.total) + "</b></p></div>" +
          '<button type="button" class="btn btn--primary btn--block compo__cta" data-compo-carte data-libelle="Ajouter ma sélection · ' + euros(r.carte.total) + '">Ajouter ma sélection · ' + euros(r.carte.total) + "</button>" +
          '<p class="compo__note">Expédié sous 24 h ouvrées. Satisfait ou remboursé 14 jours.</p>';
      }
    }
    resultat.innerHTML = h;
    majMobile(r);
    marquer();
  };

  var mobile = $("[data-compo-mobile]");
  // Barre mobile collante : même bouton que le résultat (« Ajouter au panier · X € », ajout sur place)
  var majMobile = function (r) {
    if (!mobile) return;
    var bouton = $("[data-compo-ajouter]", mobile), mention = $("[data-compo-mobile-coffret]", mobile);
    mobile.hidden = !r || !r.kit;
    if (r && r.kit) {
      $("[data-compo-mobile-libelle]", mobile).textContent = r.plusComplet ? "Plus complet et moins cher" : (r.exact ? "Votre kit sur mesure" : "Le kit le plus proche");
      if (mention) mention.hidden = !r.optionCoffret;
      if (bouton) bouton.setAttribute("data-libelle", libAjouter + " · " + euros(r.total));
    }
  };

  // Passer au kit supérieur : la sélection prend ses réactifs (pierre, volume et accessoires inchangés).
  var appliquer = function (s) {
    $$("input[name='reactif']").forEach(function (i) { i.checked = s.codes.indexOf(i.value) >= 0; });
    rendre();
    var cible = $(".compo__offre"); if (cible) { cible.classList.add("is-pop"); }
  };

  // Ajout au panier, un seul à la fois. ajout.genre : « kit » (bouton principal et barre mobile, [data-compo-ajouter]) ou « carte »
  // ([data-compo-carte]). État posé sur les boutons du genre concerné, et reposé après chaque rendu (rendre() recrée les boutons) :
  // « occupe » (aria-busy, chargement), puis « ajoute » (« Ajouté ✓ » pendant DUREE_AJOUTE), puis le libellé (data-libelle) revient.
  var ajout = { etat: "", genre: "" }, DUREE_AJOUTE = 2000, minuterie = null;
  var marquer = function () {
    $$("[data-compo-ajouter], [data-compo-carte]").forEach(function (b) {
      var vise = !!ajout.etat && ajout.genre === (b.hasAttribute("data-compo-carte") ? "carte" : "kit"), fait = vise && ajout.etat === "ajoute";
      if (vise && ajout.etat === "occupe") b.setAttribute("aria-busy", "true"); else b.removeAttribute("aria-busy");
      b.classList.toggle("is-ajoute", fait);
      var t = fait ? libAjoute : b.getAttribute("data-libelle");
      if (t && b.textContent !== t) b.textContent = t;
    });
  };
  // Refus de Shopify (épuisé, quantité) : TestOrPanier.ajouter ouvre le panier latéral avec le message, sans rejeter la promesse
  var refusPanier = function () { var el = document.querySelector("div[data-panier] [data-panier-erreur]"); return !!(el && !el.hidden && el.textContent.trim()); };
  var ajouter = function (lignes, bouton, genre) {
    if (!lignes || !lignes.length || ajout.etat) return; // ajout en cours (double clic) ou « Ajouté ✓ » affiché : ignoré
    var items = lignes.map(function (l) { return { id: l.id, quantity: 1 }; });
    ajout = { etat: "occupe", genre: genre };
    marquer();
    var fin = function (reussi) {
      ajout = { etat: reussi ? "ajoute" : "", genre: genre };
      marquer();
      if (reussi) minuterie = setTimeout(function () { ajout = { etat: "", genre: "" }; marquer(); }, DUREE_AJOUTE);
    };
    // Kit d'abord dans items. Le panier latéral (test-or.js) envoie la liste à l'envers, car Shopify range chaque article reçu en tête
    // du panier, puis s'ouvre ; le repli sans panier latéral fait de même, pour que le kit reste en tête du panier. Aucune redirection.
    if (window.TestOrPanier) { window.TestOrPanier.ajouter(items, bouton).then(function () { fin(!refusPanier()); }, function () { fin(false); }); return; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items.slice().reverse() })
    }).then(function (rep) { fin(!!rep.ok); }, function () { fin(false); });
  };

  racine.addEventListener("click", function (e) {
    var b = e.target.closest("[data-raccourci]");
    if (b) {
      var codes = b.getAttribute("data-raccourci").split(",");
      $$("input[name='reactif']").forEach(function (i) { i.checked = !i.disabled && codes.indexOf(i.value) >= 0; });
      rendre(); return;
    }
    if (e.target.closest("[data-compo-passer]") && courant && courant.superieur) { appliquer(courant.superieur); return; }
    var a = e.target.closest("[data-compo-ajouter]");
    if (a) { if (courant && courant.kit) ajouter(courant.lignes, a, "kit"); return; }
    var ac = e.target.closest("[data-compo-carte]");
    if (ac && courant) ajouter(courant.carte.lignes, ac, "carte");
  });
  form.addEventListener("change", function () { rendre(); });

  // Mobile : la bulle de l'assistant (section to-assistant, fixe en bas à droite) ne recouvre pas le composeur. Tant que le
  // formulaire (cases et résultat) passe sous la bulle, html.compo-sous-assistant la retire (to-sur-mesure.css, sous 900 px) ;
  // elle revient au-dessus et en dessous du formulaire. La bulle apparaît plus tard (serveur prêt) : suivie par son attribut hidden.
  var assistant = document.querySelector("[data-assistant]");
  if (assistant) {
    var prevu = false;
    var sousAssistant = function () {
      prevu = false;
      var b = assistant.getBoundingClientRect(), f = form.getBoundingClientRect();
      document.documentElement.classList.toggle("compo-sous-assistant", b.height > 0 && f.top < b.bottom && f.bottom > b.top);
    };
    var planifier = function () { if (!prevu) { prevu = true; window.requestAnimationFrame(sousAssistant); } };
    window.addEventListener("scroll", planifier, { passive: true });
    window.addEventListener("resize", planifier);
    if (window.MutationObserver) new MutationObserver(planifier).observe(assistant, { attributes: true, attributeFilter: ["hidden", "class"] });
    planifier();
  }

  // Sélection de départ depuis l'URL (?reactifs=14k,18k&vol=15&pierre=150&coffret=1&balance=1&loupe=1) : quiz, assistant, packs.
  var q = new URLSearchParams(location.search);
  if (q.get("reactifs")) {
    var demandes = q.get("reactifs").toLowerCase().split(/[,\s]+/);
    $$("input[name='reactif']").forEach(function (i) { i.checked = demandes.indexOf(i.value) >= 0; });
  }
  if (q.get("vol") === "15") $("input[name='vol'][value='15']").checked = true;
  var pierreQ = $("input[name='pierre'][value='" + (q.get("pierre") === "150" ? "150" : "62") + "']");
  if (pierreQ) pierreQ.checked = true;
  var coffretQ = $("input[name='coffret'][value='" + (q.get("coffret") === "1" ? "1" : "0") + "']");
  if (coffretQ) coffretQ.checked = true;
  ["balance", "loupe"].forEach(function (k) { var i = $("input[name='" + k + "']"); if (i && q.get(k) === "1") i.checked = true; });
  rendre();
})();
